import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {IPageData, UIError} from 'common/interfaces';
import {IStoreUsersState} from 'common/interfaces/istore';
import {IUser} from 'common/interfaces/iuser';

const initialState: IStoreUsersState = {
  loading: false,
  error: null,
  storeId: null,
  users: null,
};

const reducers = {
  setLoading: (state: IStoreUsersState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (
    state: IStoreUsersState,
    action: PayloadAction<UIError | null>,
  ) => {
    state.error = action.payload;
  },
  resetContext: (state: IStoreUsersState) => {
    state = initialState;
  },
  setStoreId: (
    state: IStoreUsersState,
    action: PayloadAction<number | null>,
  ) => {
    state.storeId = action.payload;
  },
  setUsers: (
    state: IStoreUsersState,
    action: PayloadAction<IPageData<IUser> | null>,
  ) => {
    state.users = action.payload;
  },
  addUsers: (
    state: IStoreUsersState,
    action: PayloadAction<IPageData<IUser> | null>,
  ) => {
    if (action.payload) {
      const stUsers = state.users?.items || [];
      const payLoadUsers = action.payload.items || [];
      state.users = {
        ...action.payload,
        items: [...stUsers, ...payLoadUsers],
      };
    }
  },
};

const storeUsersSlice = createSlice({
  name: 'IStoreUsersState',
  initialState: initialState,
  reducers: reducers,
});

export default storeUsersSlice.reducer;
export const StoreUsersActions = storeUsersSlice.actions;
